import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 20s10 -16 18 -16","key":"svg-0"}]]

const IconEaseOut = createReactComponent('outline', 'ease-out', 'EaseOut', __iconNode);

export default IconEaseOut;